import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {DefaultLayoutComponent} from './containers/default-layout';
import {AuthGuardService} from './services/auth/auth-guard.service';
import {AuthCallbackComponent} from './auth-callback/auth-callback.component';

@NgModule({
  imports: [
    RouterModule.forRoot([
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      {path: 'auth-callback', component: AuthCallbackComponent},
      {
        path: '', component: DefaultLayoutComponent,
        children: [
          {path: 'home', loadChildren: () => import('../app/components/home/home.module').then(m => m.HomeModule)},
          {path: 'hrm-header', loadChildren: () => import('../app/features/hrm-header/hrm-header.module').then(m => m.HrmHeaderModule)},
          // {path: 'uni', loadChildren: () => import('../app/components/demo/demo.module').then(m => m.DemoModule)},
        ], canActivate: [AuthGuardService]
        // canActivate: [AuthGuardService]
      },
      {path: '**', redirectTo: '/notfound'},
    ])
    // ], { scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled', onSameUrlNavigation: 'reload' })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
